import React, { Component } from 'react';
import $ from "jquery";

export default class OptSearch5 extends Component {

    constructor(props) {
        super(props);
        this.state = { data: { ...props.data }, searchValue: "" };
    }

    submitOptForm = (needReload = false) => {
        let match = "{";
        var inputText = $("#search-text").val();

        const OptSearchUrl = window.location.pathname;
        let params = {};

        $("p.selected").text(inputText);
        $("p.selected").attr("data-value", inputText);

        let searchValue = $("td.search-row-text").find("p.selected").data("value") || "";
        if (searchValue) {
            params["search"] = searchValue;
        }

        $(".search-row").not(".search-row-text").each(function () {
            var title = $(this).children(".search-form__td-title").attr("value");
            var value = $(this).find("li.selected").attr("value");
            //console.log($(this).children(".search-form__td-title").attr("value"));
            //console.log("Title: " + title + ", Value: " + value);
            if (title && value) {
                params[title] = value;
                match += `"${title}":"${value}", `;
                sessionStorage.setItem(title, value);
            }
        });

        let queryString = Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        //console.log("Query String: " + queryString);

        let newUrl = `${OptSearchUrl}?${queryString}`;
        window.history.pushState(null, '', newUrl);

        if (needReload) {
            //console.log("Reloading page with new parameters.");
            window.location.reload();
        }
    }

    clear = () => {
        sessionStorage.clear();
        window.location.reload();
    }

    componentDidMount() {
        const currentPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        sessionStorage.setItem('OptSearchUrl', currentPath);

        const searchText = String(urlParams.get('search'))
        const author = String(urlParams.get('id_author'))
        const category = String(urlParams.get('id_category'))
        const year = String(urlParams.get('id_year'))

        let setReload = true;
        let optSearchObj = {};

        if (searchText) {
            sessionStorage.setItem('search', searchText);
            optSearchObj["search"] = searchText;
        }
        if (author) {
            sessionStorage.setItem('id_title', author);
            optSearchObj["id_title"] = author;
        }
        if (category) {
            sessionStorage.setItem('id_sender', category);
            optSearchObj["id_sender"] = category;
        }
        if (year) {
            sessionStorage.setItem('id_recipient', year);
            optSearchObj["id_recipient"] = year;
        }

        sessionStorage.setItem('OptSearch', JSON.stringify(optSearchObj));

        this.loadFiltersFromSessionStorage();

        if (!sessionStorage.getItem('submitFormCalled') && setReload) {
            this.submitOptForm();
            sessionStorage.setItem('submitFormCalled', 'true');
        } else {
            const storedAauthor = sessionStorage.getItem('id_author');
            const storedCategory = sessionStorage.getItem('id_category');
            const storedYear = sessionStorage.getItem('id_year');

            if (
                author === storedAauthor &&
                category === storedCategory &&
                year === storedYear
            ) {
                setReload = false;
                sessionStorage.removeItem('submitFormCalled');
                //console.log('Filtry są takie same, nie wymagają przeładowania.');
            }
        }
    }

    loadFiltersFromSessionStorage() {
        let searchText = sessionStorage.getItem('search');
        let author = sessionStorage.getItem('id_author');
        let category = sessionStorage.getItem('id_category');
        let year = sessionStorage.getItem('id_year');

        const urlParams = new URLSearchParams(window.location.search);
        const searchTextUrl = urlParams.get('search');
        const authorUrl = urlParams.get('id_author');
        const categoryUrl = urlParams.get('id_category');
        const yearUrl = urlParams.get('id_year');

        if ((searchText != null && searchText === searchTextUrl)) {
            $("#search-text").val(searchText);
            $("p.selected").text(searchText);
            $("p.selected").attr("data-value", searchText);
        }

        if (author != null && author === authorUrl) {
            $("#author li").removeClass("selected");
            $("#author li").each(function () {
                if ($(this).attr("value") === author) {
                    $(this).addClass("selected");
                }
            });
        }

        if (category != null && category === categoryUrl) {
            $("#category li").removeClass("selected");
            $("#category li").each(function () {
                if ($(this).attr("value") === category) {
                    $(this).addClass("selected");
                }
            });
        }

        if (year != null && year === yearUrl) {
            $("#year li").removeClass("selected");
            $("#year li").each(function () {
                if ($(this).attr("value") === year) {
                    $(this).addClass("selected");
                }
            });
        }
    }

    render() {

        document.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("search-engine-submit").click();
            }
        });

        $(function () {
            $(".select-container ul").unbind().click(function () {
                $(this).toggleClass("opened");
            });

            $("#optional-search-form ul li").click(function () {
                var match = "{";
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
                $("p.selected").attr("value", inputText)

                if ($(this).hasClass("selected")) {
                }
                else {
                    $(this).addClass("selected").siblings().removeClass("selected");

                    const parentId = $(this).parent("ul").attr('id');
                    const itemValue = $(this).attr("value");
                    sessionStorage.setItem(`id_${parentId}`, itemValue)

                    $(".search-row").each(function () {
                        var title = $(this).children(".search-form__td-title").attr("value");
                        var value = $(this).find(".selected").attr("value");
                        match += '"' + title + '":';
                        match += '"' + value + '", ';
                    });

                }
                match = match.slice(0, -2);
                match += "}";
                sessionStorage.setItem("OptSearch4", match);
            });

            $('#search-text').on('input', function (e) {
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
            });

        });

        $(document).mouseup(function (e) {
            var container = $(".select-container ul.opened");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass("opened");
            }
        });


        // LABELS BASED ON LANGUAGE
        let search_label_1 = window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
        let search_label_2 = window.location.href.indexOf("/en/") > -1 ? "Enter a search phrase" : "Wpisz szukaną frazę";
        let search_label_3 = window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
        let search_label_4 = window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
        let search_label_5 = window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

        const keepOpen = () => {
            document.getElementById("author").classList.add("opened")
        }

        const searchItems = (event) => {
            this.setState({
                searchValue: event.target.value.toLowerCase()
            });

        }

        const displayIfSearched = (name) => {

            if (this.state.searchValue !== "" && name.toLowerCase().search(this.state.searchValue) === -1) {
                return "pointAuthorSearched"
            } else {
                return ""
            }
        }


        return (
            <div className="optional-search-container">

                <form id="optional-search-form" className="OptSearch5">
                    <table>
                        <tr className="search-row">
                            <td colSpan={2} className="search-row-text search-form__td-title" value="search">
                                <input id="search-text" type="text" placeholder={search_label_2} aria-label={search_label_2} />
                                <p className="selected" style={{ margin: 0 }}></p>
                            </td>
                        </tr>

                        <tr>
                            <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[0].field_name}>{this.props.filter_search[0].name}</span>
                                <div className="select-container">
                                    <ul id="author">
                                        <li id={"searchAuthor"}><input aria-label={search_label_3} type={"text"} placeholder={search_label_3} onClick={() => keepOpen()} onChange={(event) => searchItems(event)} /></li>
                                        <li className="selected" value="">{search_label_4}</li>
                                        {this.props.filter_search[0].list.map(function (item) {
                                            var name = item.name;
                                            var id = item.id;
                                            return (
                                                <li value={id} className={`pointAuthor ${displayIfSearched(name)}`} dangerouslySetInnerHTML={{ __html: name }}></li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </td>
                            <td className="search-row"><span className="search-form__td-title" value={this.props.filter_search[1].field_name}>{this.props.filter_search[1].name}</span>
                                <div className="select-container">
                                    <ul id="category">
                                        <li className="selected" value="">{search_label_4}</li>
                                        {this.props.filter_search[1].list.map(function (item) {
                                            var name = item.name;
                                            var id = item.id;
                                            return (
                                                <li value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td className="search-row" colSpan={2}><span className="search-form__td-title" value={this.props.filter_search[2].field_name}>{this.props.filter_search[2].name}</span>
                                <div className="select-container">
                                    <ul id="year">
                                        <li className="selected" value="">{search_label_4}</li>
                                        {this.props.filter_search[2].list.map(function (item) {
                                            var name = item.name;
                                            var id = item.id;
                                            return (
                                                <li value={id} dangerouslySetInnerHTML={{ __html: name }}></li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </table>

                    <div className="search-engine-options">
                        <button onClick={this.clear}>{search_label_1}</button>
                        <button id="search-engine-submit" className="submit" onClick={(e) => { e.preventDefault(); this.submitOptForm(true); }}>{search_label_3}</button>
                    </div>
                </form>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch5/OptSearch5.js